// Shared domain types for the MCF Master Group prototype.
// Keep this file limited to cross-cutting types used by more than one component.
// Repeating content (services, FAQs, testimonials, process steps) intentionally
// lives as top-of-file const arrays inside the section that renders it — see
// handover/bricks-component-mapping.md for why (Bricks/WordPress portability).

export type ServiceType =
  | 'roller-shutters'
  | 'outdoor-blinds'
  | 'electrical'
  | 'repairs'
  | 'commercial-shutters'
  | 'guide-only';

export type ContactMethod = 'phone' | 'email';

export type PlannerPriority = 'security' | 'comfort' | 'light' | 'privacy' | 'control' | 'not-sure';
export type PlannerScope = '1-2' | '3-5' | '6-plus' | 'not-sure';
export type PlannerControlPref = 'manual' | 'electric' | 'smart' | 'help-me-choose';

export interface PlannerAnswers {
  priority: PlannerPriority | null;
  scope: PlannerScope | null;
  control: PlannerControlPref | null;
}

export interface SubmissionRecord {
  name: string;
  suburb: string;
  service: ServiceType;
  contactMethod: ContactMethod;
  contactValue: string;
}

export const SERVICE_LABELS: Record<ServiceType, string> = {
  'roller-shutters': 'Roller shutters (new installation)',
  'outdoor-blinds': 'Outdoor blinds (Ziptrak)',
  electrical: 'Electrical services',
  repairs: 'Repairs & servicing',
  'commercial-shutters': 'Commercial shutters',
  'guide-only': 'Just the planning pack / general enquiry'
};

export const SERVICE_ORDER: ServiceType[] = [
  'roller-shutters',
  'outdoor-blinds',
  'electrical',
  'repairs',
  'commercial-shutters',
  'guide-only'
];
